const errorsTranslations = {
    user_does_not_exist: 'Email ou mot de passe incorrect',
    holiday_already_requested: 'Une absence a déjà été demandée pour cette période',
    holiday_cant_be_on_weekends: 'Une absence ne peut pas être demandée pour un week-end',
    missing_token: 'Vous avez été déconnecté, veuillez vous reconnecter',
    missing_id: 'Identifiant manquant',
    missing_mail: 'Adresse e-mail manquante',
    missing_password: 'Mot de passe manquant',
    missing_date_start: 'Date de début manquante',
    missing_date_end: 'Date de fin manquante',
    missing_operator_id: "Identifiant de l'ouvrier manquant",
    missing_holiday_id: "Identifiant de l'absence manquant",
    missing_id_category: 'Identifiant de la catégorie manquant',
    missing_test_sheet_id: 'Identifiant du rapport de contrôle manquant',
    missing_worksite_id: 'Identifiant du chantier manquant',
    missing_apartment_id: 'Identifiant du logement manquant',
    missing_questions: 'Questions manquantes',
    missing_id_question: 'Identifiant de la question manquant',
    missing_worker_name: "Nom de l'ouvrier manquant",
    missing_worker_first_name: "Prénom de l'ouvrier manquant",
    missing_hours: "Nombre d'heures manquant",
    missing_type_id: 'Identifiant du type manquant',
    missing_task_id: 'Identifiant de la tâche manquante',
    missing_answers: 'Réponses manquantes',
    missing_call_date: "Date d'intervention manquante",
    missing_call_by: "Nom de l'appelant manquant",
    missing_apartment_text: 'Description du logement manquante',
    missing_address: 'Adresse du chantier manquante',
    missing_type: 'Type de chantier manquant',
    missing_start_time: "Heure de début de l'intervention manquante",
    missing_end_time: "Heure de fin de l'intervention manquante",
    missing_request_nature: 'Nature de la demande manquante',
    missing_completed_works: 'Travaux réalisés manquants',
    missing_client: 'Nom du client manquant',
    missing_id_quitus: 'Identifiant du quitus manquant',
    missing_title: 'Titre manquant',
    missing_product_id: 'Identifiant du produit manquant',
    missing_quantity: 'Quantité manquante',
    missing_id_favorite: 'Identifiant du favori manquant',
    missing_event_type: "Type d'événement manquant",
    missing_event_destination: "Lieu de l'événement manquant",
    missing_reference: 'Référence manquante',
    missing_ppsps: "Aucun PPSPS n'a été trouvé pour ce chantier",
    no_formations_available: 'Aucune formation disponible',
    wrong_period: 'Période invalide',
    invalid_call_date: "Date d'intervention invalide",
    title_already_exists: 'Titre déjà existant',
    talk_not_found: 'Discussion non trouvée',
    quitus_doesnt_exist: 'Quitus introuvable',
    problem_happened: 'Un problème est survenu',
    internal_error: 'Une erreur interne est survenue',
    problem_during_update: 'Un problème est survenu lors de la mise à jour',
    invalid_token: 'Vous avez été déconnecté, veuillez vous reconnecter',
    internal_server_error: 'Une erreur inconnue est survenue, veuillez réessayer plus tard'
};

export default errorsTranslations;
